// extracted by mini-css-extract-plugin
export var bold = "_ru-0";